/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
// import { useSelector } from "react-redux";
import React, { useContext } from "react";
import { TableCell, TableRow } from "@mui/material";
import * as Sentry from "@sentry/react";
import { tabelCellWidth, style } from "./styles";
import { isEmptyObj } from "../../utils/helper";
// import { selectAllSIUsers } from "../../redux/selectors/user";
import Button from "../common/Button";
import Typography from "../common/new/Typography/Typography";
import { ToastAlertContext } from "../../config/providers/ToastAlert";
import { AlertStatus } from "../../contants";
import Appointment from "../../services/api/appointment";

function AppointmentApply({ member, onMemberSelect }) {
  // const { isDistrictSi, isChapterSi, isRegionSi, isAreaSi, isZoneSi } =
  //   useSelector(selectAllSIUsers);
  const toast = useContext(ToastAlertContext);

  if (isEmptyObj(member)) {
    return null;
  }

  const memberEligibility = async () => {
    try {
      const response = await Appointment.AppointmentApplyEligibility(
        member.memberId
      );
      if (response.message === "eligible") {
        onMemberSelect(member.memberId, response.message);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);

      Sentry.captureException(error);
    }
  };

  const handleApplyClick = () => {
    memberEligibility(); // Call the API when the "Apply" button is clicked
  };

  return (
    <TableRow>
      <TableCell style={{ ...style.rowStyleId, ...tabelCellWidth.tiny }}>
        {" "}
        {member.memberId}
      </TableCell>
      <TableCell style={{ ...style.rowStyle, ...tabelCellWidth.small }}>
        {" "}
        <Typography style={style.typogrphyStyle}>
          {" "}
          {member.fullName}{" "}
        </Typography>
        <br /> <br />{" "}
        <Typography style={style.typogrphyStyle}>
          {member.addressLine1}
        </Typography>
      </TableCell>
      <TableCell style={{ ...style.rowStyle, ...tabelCellWidth.small }}>
        {" "}
        <Typography style={style.typogrphyStyle}>
          {member.mobileNumber || "-"}
        </Typography>{" "}
        <br />
        <br />
        <Typography style={style.typogrphyStyle}>{member.emailId}</Typography>
      </TableCell>
      <TableCell style={style.rowStyle}>
        <Typography style={style.typogrphyStyle}>
          {member.divisionName || "-"}{" "}
        </Typography>
      </TableCell>
      <TableCell style={{ ...style.rowStyleOS, ...tabelCellWidth.medium }}>
        {/* {isDistrictSi
          ? member.blockName
          : isChapterSi
          ? member.districtName
          : isRegionSi
          ? member.chapterName
          : isZoneSi
          ? member.regionName
          : isAreaSi
          ? member.zoneName
          : "-"} */}
        {[
          member?.areaName,
          member?.clusterName,
          member?.zoneName,
          member?.regionName,
          member?.chapterName,
          member?.districtName,
          member?.blockName,
        ]
          .filter(Boolean)
          .join("/ ")}
      </TableCell>
      {/* <TableCell style={style.Cell}>{member.currentPosition || "-"}</TableCell> */}
      <TableCell style={tabelCellWidth.small}>
        <Button
          variant="outlined"
          style={style.applyButton}
          // onClick={() => onMemberSelect(member.memberId)}
          onClick={() => handleApplyClick()}
          label=" APPLY"
        />
      </TableCell>
    </TableRow>
  );
}

export default AppointmentApply;
